import React from "react";
import { spacing } from "../library/theme";

const paragraph = { flex: 1, textAlign: "center", paddingTop: spacing.m };

export default function TagsEmpty() {
  return <p style={paragraph}>Nenhum resultado.</p>;
}
